import * as React from 'react'
import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import '../css/footer.css'
import AppProps from '../util/appProps'
import {tagger} from '../util/util'
import { locales } from '../util/locales'

const takeYouAppMap = new Map([
    ['/', 'Lets take your a'],
    ['/rtb', 'RTB Lets build'],
    ['/monetization', 'Monetize'],
    ['/market-research', 'MR Reach']
])

const Footer = (props: AppProps) => {

    const shortFooterPaths = [
        '/gdpr',
        '/privacy_policy',
        '/security',
        '/login',
        '/sign_up',
        '/welcome',
        '/welcomeBack',
        '/forgot_password',
        '/terms_use',
        '/privacy_dsp',
        '/privacy_sdk',
        '/getInTouch',
        '/contact',
        '/mrcontact',
        '/restored',
        '/context-distance-calculator'
    ]
    const {t, i18n} = useTranslation('footer')
    const i18nCommon = useTranslation('common').t

    const [state, setState] = useState({
        textColor: '',
        buttonColor: '',
        buttonText: ''
    })

    const path = props.location.pathname.substring(3)

    useEffect(() => {
        switch (path) {
            case '/rtb':
                setState({
                    textColor: 'aqua-text fw700',
                    buttonColor: 'button-aqua large',
                    buttonText: 'Start Now'
                })
                break
            case '/monetization':
                setState({
                    textColor: 'red-text fw700',
                    buttonColor: 'button-red large',
                    buttonText: 'Start Now'
                })
                break
            default:
                setState({
                    textColor: 'accent-text fw700',
                    buttonColor: 'button-blue large',
                    buttonText: 'Get Started'
                })
        }
    }, [props.location.pathname])

    const pathKey = takeYouAppMap.get(path)

    return (
        <div className="footer-container">
            <div className="footer">
                {!shortFooterPaths.includes(path) && <div className="f-ready-to-go">
                    <div className="footer-t muli">{i18nCommon('Ready to Go?')}</div>
                    <div
                        className="footer-d">{tagger(i18nCommon(pathKey || takeYouAppMap.get('/') as string), state.textColor)}</div>
                    <Link to="/contact">
                        <button className={state.buttonColor}>{i18nCommon(state.buttonText)}<img src="https://static.persona.ly/images/arrow.svg"/></button>
                    </Link>
                </div>}
                <div className="f-main">
                    <div className="footer-info">
                        <div>
                            <div className={state.textColor}>{t('Solutions')}</div>
                            <ul>
                                <li><Link to="rtb">{t('Programmatic UA')}</Link></li>
                                <li><Link to="rtb#retargeting">{t('Re-targeting')}</Link></li>
                                <li><Link to="market-research">{t('Market Research')}</Link></li>
                                <li><Link to="monetization">{t('Monetization')}</Link></li>
                            </ul>
                        </div>
                        <div>
                            <div className={state.textColor}>{t('Resources')}</div>
                            <ul>
                                <li><a href={'/blog/' + (i18n.language.includes(locales.en) ? '' : i18n.language.substring(0,2))}>{t('Blog')}</a></li>
                                <li><a href="/glossary">UA Glossary</a></li>
                                <li><Link to="rtb#case-studies">Case Studies</Link></li>
                                <li><a href="http://knowledge.persona.ly">{t('Knowledge Base')}</a></li>
                                <li><Link to="context-distance-calculator">{t('Context Distance Calculator')}</Link></li>
                                {/* <li>CPE Campaigns</li>
                                <li>Testimonials</li>
                                <li>Attribution</li> */}
                            </ul>
                        </div>
                        <div>
                            <div className={state.textColor}>{t('About')}</div>
                            <ul>
                                <li><Link to="about">{t('Values and Ideals')}</Link></li>
                                <li><Link to="about#careers">{t('Careers')}</Link></li>
                                <li><Link to="about#offices">{t('Our Offices')}</Link></li>
                                <li><Link to="about#contact">{t('Contact Us')}</Link></li>
                                <li><Link to="security">{t('Information Security')}</Link></li>
                                <li><Link to="gdpr">{t('GDPR')}</Link></li>
                            </ul>
                        </div>
                        <div>
                            <div className={state.textColor}>{t('Social')}</div>
                            <ul>
                                <a className="fb" href="https://www.facebook.com/persona.ly.monetization/"/>
                                <a className="ln" href="https://www.linkedin.com/company/persona-ly/"/>
                                <a className="tw" href="https://twitter.com/persona_ly"/>
                            </ul>
                            <ul>
                                <li className="not-desktop fs12 f-m fw700">INFO@PERSONA.LY</li>
                                <li className="not-desktop fs12 f-m fw700">+1-888-724-8205</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="footer-pr fw700 not-desktop not-tablet">
                    <span><Link to="privacy_policy">{t('privacy policy')}</Link></span>
                    <span><Link to="terms_use">{t('terms of use')}</Link></span>
                </div>
            </div>
        </div>
    )
}

export default Footer



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/footer.tsx